import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=b187e3f8&"
import script from "./VideoEmbed.vue?vue&type=script&lang=js&"
export * from "./VideoEmbed.vue?vue&type=script&lang=js&"
import style0 from "./VideoEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports